import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>
                    Top tien voedselproducten met het hoogste eiwitgehalte
                </title>
                <link rel="canonical" href={route("blogs.forty-one")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Als sporter is het belangrijk om voldoende eiwitten binnen te krijgen voor spierherstel en -opbouw. Eiwitten zijn namelijk de bouwstenen van onze spieren en een tekort aan eiwitten kan leiden tot verminderde prestaties en hersteltijd."
                />
                <meta
                    property="og:description"
                    content="Als sporter is het belangrijk om voldoende eiwitten binnen te krijgen voor spierherstel en -opbouw. Eiwitten zijn namelijk de bouwstenen van onze spieren en een tekort aan eiwitten kan leiden tot verminderde prestaties en hersteltijd."
                />
                <meta property="og:url" content={route("blogs.forty-one")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Top tien voedselproducten met het hoogste eiwitgehalte - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/top-10-voeding-eiwitgehalte.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/top-10-voeding-eiwitgehalte.webp"
                                    type="image/webp"
                                    alt="Top tien voedselproducten met het hoogste eiwitgehalte"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/top-10-voeding-eiwitgehalte.jpg"
                                    type="image/jpeg"
                                    alt="Top tien voedselproducten met het hoogste eiwitgehalte"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/top-10-voeding-eiwitgehalte.jpg"
                                    alt="Top tien voedselproducten met het hoogste eiwitgehalte"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Top tien voedselproducten met het hoogste eiwitgehalte
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Als sporter is het belangrijk om voldoende eiwitten
                        binnen te krijgen voor spierherstel en -opbouw. Eiwitten
                        zijn namelijk de bouwstenen van onze spieren en een
                        tekort aan{" "}
                        <a
                            href={route("blogs.third")}
                            className="text-we-are-yellow"
                        >
                            eiwitten
                        </a>{" "}
                        kan leiden tot verminderde prestaties en hersteltijd.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        In deze blogpost zullen we de top tien voedselproducten
                        bespreken die het hoogste gehalte aan eiwitten bevatten.
                        Deze producten kunnen je helpen om jouw dagelijkse
                        eiwitbehoefte te bereiken en optimaal te profiteren van
                        jouw trainingssessies.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        10. Magere kwark
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Kwark is een geweldige bron van caseïne-eiwit, dat
                        langzaam wordt verteerd en gedurende lange tijd
                        aminozuren aan je spieren levert. Het bevat ook weinig
                        vet en koolhydraten, waardoor het een populaire keuze is
                        onder sporters.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        9. Kipfilet{" "}
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Kipfilet is mager{" "}
                        <a
                            href={route("blogs.twenty-five")}
                            className="text-we-are-yellow"
                        >
                            vlees
                        </a>{" "}
                        dat rijk is aan eiwitten. Het bevat weinig vet en is
                        gemakkelijk te bereiden. Je kunt het grillen, bakken of
                        toevoegen aan salades voor een heerlijke en eiwitrijke
                        maaltijd.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        8. Tonijn
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Tonijn is niet alleen lekker, maar ook een uitstekende
                        bron van eiwitten. Het bevat ook{" "}
                        <a
                            href={route("blogs.sixteenth")}
                            className="text-we-are-yellow"
                        >
                            omega-3 vetzuren
                        </a>{" "}
                        die ontstekingsremmend kunnen werken en de gezondheid
                        van je hart bevorderen.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        7. Eieren
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Eieren zijn een goedkope en veelzijdige bron van
                        eiwitten. Ze kunnen op verschillende manieren worden
                        bereid - gekookt, gebakken of geroerd - en zijn perfect
                        voor het ontbijt of als tussendoortje.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        6. Griekse yoghurt
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Griekse yoghurt heeft een hoger eiwitgehalte dan gewone
                        yoghurt omdat het wordt gespannen om de wei te
                        verwijderen. Het kan worden gegeten als dessert,
                        toegevoegd aan smoothies of gebruikt als basis voor
                        dipsauzen.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        5. Linzen
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Linzen zijn peulvruchten die boordevol vezels en
                        eiwitten zitten. Ze zijn ideaal voor vegetariërs en
                        veganisten, maar ook voor iedereen die op zoek is naar
                        een gezonde eiwitbron.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        4. Kalkoenfilet
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Kalkoenfilet is mager vlees dat weinig vet en veel
                        eiwitten bevat. Het kan worden gebruikt als basis voor
                        sandwiches, toegevoegd aan salades of gegrild als
                        hoofdgerecht.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        3. Magere melk
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Magere melk is niet alleen een goede bron van eiwitten,
                        maar ook van calcium en vitamine D. Het kan worden
                        gedronken als tussendoortje of worden toegevoegd aan
                        smoothies en havermout voor extra voedingsstoffen.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        2. Quinoa
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Quinoa is een populair graan dat rijk is aan eiwitten en
                        andere voedingsstoffen zoals vezels, ijzer en magnesium.
                        Het kan worden gebruikt als basis voor salades,
                        bijgerechten of zelfs als vervanger voor rijst in
                        gerechten.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        1. Zalm
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Zalm staat bovenaan de lijst vanwege het hoge gehalte
                        aan eiwitten en omega-3 vetzuren. Deze combinatie maakt
                        het een uitstekende keuze om spierherstel te bevorderen
                        en ontstekingen te verminderen.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Conclusie
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Het consumeren van deze top tien voedselproducten met
                        het hoogste eiwitgehalte zal je helpen bij het bereiken
                        van jouw dagelijkse eiwitdoelen. Ze zijn niet alleen
                        voedzaam, maar ook lekker en gemakkelijk te bereiden.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Onthoud dat het belangrijk is om een gebalanceerd dieet
                        te volgen en voldoende variatie in je voeding aan te
                        brengen. Combineer deze eiwitrijke voedingsmiddelen met
                        gezonde koolhydraten, vetten en groenten voor optimale
                        sportprestaties.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Eet smakelijk en geniet van jouw fitjourney!
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
